import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";

const client = new ApolloClient({
  link: new HttpLink({
    uri: process.env.UGG_PUBLIC_GRAPHQL_WP_URL,
  }),
  cache: new InMemoryCache(),
});

export default client;
